import React from 'react';
import { Link } from 'react-router-dom';
import { View, Text, Button, Flex } from '@aws-amplify/ui-react';
import { usePersonalInsurancePendingSummary } from '../hooks/usePersonalInsurancePendingSummary';

export default function Personalinsurancependingbanner({ enabled = true, refreshKey = 0, fleetCode = null }) {
  const { totalPending, byFleet } = usePersonalInsurancePendingSummary({
    enabled,
    refreshKey,
    fleetCode: fleetCode || undefined,
  });

  if (!enabled || totalPending < 1) {
    return null;
  }

  return (
    <View
      style={{
        background: '#fff8f0',
        border: '1px solid #f0a500',
        borderRadius: 8,
        padding: '0.75rem 1rem',
        marginBottom: '1rem',
      }}
    >
      <Flex direction="row" justifyContent="space-between" alignItems="center" wrap="wrap" gap="0.5rem">
        <View>
          <Text fontWeight="bold">
            {totalPending} personal insurance upload{totalPending === 1 ? '' : 's'} awaiting review
          </Text>
          {byFleet.length > 1 ? (
            <Text fontSize="small" color="#666">
              {byFleet.map((f) => `${f.fleet_code}: ${f.pending_count}`).join(' · ')}
            </Text>
          ) : null}
        </View>
        {fleetCode ? (
          <Link to={`/personal-insurance-review?fleets=${encodeURIComponent(fleetCode)}`}>
            <Button size="small">Review queue</Button>
          </Link>
        ) : null}
      </Flex>
    </View>
  );
}
